import React, { useState } from 'react'
import moment from 'moment'
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { Input } from '@progress/kendo-react-inputs'

const KendoDatePickerFilter = props => {
  const { onChange } = props
  const [datePickerValue, setDatePickerValue] = useState(null)

  return (
    <div>
      <Input
        type="date"
        onChange={event => {
          const { value, syntheticEvent } = event
          const newValue = value !== null ? value : new Date()
          setDatePickerValue(newValue)
          onChange({
            value: moment(newValue).format('YYYY-MM-DD'),
            operator: 'eq',
            syntheticEvent: syntheticEvent,
          })
        }}
        format="dd-MM-yyyy"
        value={datePickerValue}
        style={{ width: '60%', height: '60%' }}
      />
      <button
        className="k-button k-button-icon k-clear-button-visible"
        title="Clear"
        onClick={event => {
          event.preventDefault()
          onChange({
            value: '',
            operator: '',
            syntheticEvent: event.syntheticEvent,
          })
          setDatePickerValue('')
        }}
        style={{ margin: '5 px !important' }}
      >
        <FilterAltOffIcon fontSize="small" />
      </button>
    </div>
  )
}

export default KendoDatePickerFilter
